/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:absolute;background:#4caf50;color:#fff;padding:5px;box-shadow:0 5px 10px rgba(0,0,0,.1);width:160px;text-align:center;top:21px;right:-45px;-webkit-transform:rotate(45deg);transform:rotate(45deg);letter-spacing:.5px}"];
export { styles as styles };
